export function removePageParam(url) {
  const prefix = "https://vaghfnama.ir/api/";
  if (url.startsWith(prefix)) {
    url = url.slice(prefix.length);
  }

  const u = new URL(url, "https://dummy-base");
  u.searchParams.delete("page");

  return u.pathname + (u.search ? u.search : "");
}
